import './App.css';
import { ThemeProvider } from '@material-ui/core/styles';
import theme from './theme';
import Main from './routes';

function App() {
  return (
    <ThemeProvider theme={theme}>
        <Main />
  </ThemeProvider>
  );
}

export default App;
